export default defineComponent({
  props: {
    src: String,
    title: String
  },
  setup: function setup() {}
});